export default __webpack_public_path__ + "static/media/wink-06.eee26491.svg";